import { useTranslation } from 'react-i18next'

import { ComboBox } from '@reveni-io/reveni-ui'

import { getAvailableRefundMethods } from './helpers'

const RefundMethodSelector = ({ refundMethods, refundMethodSelected, onChange, disabled }) => {
  const { t } = useTranslation()

  const availableRefundMethods = getAvailableRefundMethods(refundMethods)?.map(method => ({
    ...method,
    label: t(method.label),
  }))

  const isOnlyRefundMethodSelected =
    availableRefundMethods?.length === 1 && availableRefundMethods[0].value === refundMethodSelected

  return (
    <ComboBox
      menuItems={availableRefundMethods}
      disabled={disabled || isOnlyRefundMethodSelected}
      value={refundMethodSelected}
      label={t('Método de reembolso')}
      handleChange={e => onChange(e.target.value)}
    />
  )
}

export default RefundMethodSelector
